export default "__VITE_ASSET__Bcjn1voV__"